import { margins, widths } from '@olist/styled-system';
import styled, { css, keyframes } from 'styled-components';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Wrapper = styled.div(({ theme: { olist: { components: { textarea }, }, }, }) => css `
    display: flex;
    flex-direction: column;
    padding: 2px;

    ${Caption} {
      color: ${textarea['helper-text'].color};
    }

    ${margins}
  `);
const WrapperTextarea = styled.div(({ theme: { olist: { components: { textarea }, }, }, feedback, showFeedbackIcon, disabled, readOnly, isLoading, }) => css `
    height: 96px;

    display: flex;
    align-items: center;

    border-radius: ${textarea.radius};
    box-sizing: border-box;

    margin-top: ${textarea.margin};

    background-color: ${textarea['background-color']};
    padding: 8px 0;

    ${widths}

    ${disabled
    ? css `
          outline: 2px solid ${textarea.disabled['border-color']};
          background-color: ${textarea.disabled.background};
          cursor: not-allowed;
        `
    : feedback &&
        !showFeedbackIcon &&
        feedback != 'valid' &&
        !isLoading &&
        !readOnly
        ? css `
          outline: 2px solid ${textarea.feedback[feedback]['border-color']};
        `
        : css `
          outline: 1px solid ${textarea['border-color']};
          ${readOnly
            ? css `
                background-color: ${textarea.readOnly.background};
              `
            : ''}
        `}

    &:focus-within {
      outline: 2px solid ${textarea.focused['border-color']};
    }
  `);
const StyledTextarea = styled.textarea(({ hasPrefix, theme: { olist: { components: { textarea }, }, }, }) => css `
    background-color: transparent;
    box-shadow: none;
    border: none;
    resize: none;

    width: 100%;
    height: 100%;

    padding: ${hasPrefix
    ? `0 ${textarea.padding} 0 0`
    : `0 ${textarea.padding}`};

    &:focus {
      outline: transparent;
    }

    font-family: ${textarea['font-family']};
    line-height: ${textarea['line-height']};

    font-size: ${textarea['font-size'].desktop};

    color: ${textarea.color};

    &:disabled {
      cursor: not-allowed;
    }

    &::placeholder {
      color: ${textarea.placeholder.color};
      font-style: italic;
    }
  `);
const rotate = keyframes `
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const scaleIcon = keyframes `
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
`;
const Suprefix = styled.span(({ theme: { olist: { components: { textarea }, }, }, sufix, hasSuffix, }) => css `
    ${sufix
    ? css `
          padding-left: ${textarea.suprefix.margin};
          padding-right: ${hasSuffix ? 0 : textarea.padding};
        `
    : css `
          padding-left: ${textarea.padding};
          padding-right: ${textarea.suprefix.margin};
        `}

    color: ${textarea.suprefix.color};

    display: flex;
    height: 100%;
    align-items: center;

    ${ParagraphMd} {
      line-height: ${textarea.suprefix.paragraph['line-height']};
      color: ${textarea.suprefix.paragraph.color};
      font-size: ${textarea.suprefix.paragraph['font-size']};
    }
  `);
const FeedbackIcon = styled.div(({ hasSuffix, theme: { olist: { components: { textarea }, }, }, isLoading, feedback, }) => css `
    ${hasSuffix &&
    css `
      padding-right: 0;
    `}
    ${isLoading
    ? css `
          svg {
            animation: ${rotate} 2s linear infinite;
          }
        `
    : feedback
        ? css `
          svg {
            color: ${textarea.suprefix['feedback-icon'][feedback].color};
            animation: ${scaleIcon} 200ms ease-in;
          }
        `
        : ''}
  `);
const WrapperLabel = styled.div(() => css `
    display: flex;
    align-items: center;
  `);
const OptionalLabel = styled.span(({ theme: { olist: { components: { textarea }, }, }, }) => css `
    color: ${textarea.optionallabel.color};
    font-size: ${textarea.optionallabel['font-size']};
    font-family: ${textarea['font-family']};
    margin-left: ${textarea.optionallabel.margin};
    font-style: ${textarea.optionallabel['font-style']};
  `);
const BottomTextArea = styled.div(({ maxLength, helperText }) => css `
    display: flex;

    ${maxLength &&
    css `
      justify-content: flex-end;
    `}

    ${maxLength &&
    helperText &&
    css `
      justify-content: space-between;
    `}
  `);
const CharacterCounter = styled(Caption)(({ theme, maxLength, characterCounter }) => css `
    ${maxLength &&
    characterCounter > maxLength &&
    css `
      color: ${theme.olist.color.alert.base} !important;
    `}
  `);

export { BottomTextArea, CharacterCounter, FeedbackIcon, OptionalLabel, StyledTextarea, Suprefix, Wrapper, WrapperLabel, WrapperTextarea };
